<ng-container>
  <button (click)="setEmpty()" class="btn btn-xs btn-light float-right">
    <i class="la la-times-circle"></i>
    {{ "navigations.clear" | translate }}
  </button>
</ng-container>
